import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();
document.addEventListener("DOMContentLoaded", () => {

	if (document.body.classList.contains("page-template-text-only-page")) return;

	let dataAttribute = jQuery("#main-content-block").attr("data-page-id");

	jQuery.ajax({
		type: "POST",
		url: wp_helper.ajax_url,
		data: {
			action: "toc_ajax_shortcode",
			postId: dataAttribute,
		},
		success: function (res) {

			if (document.body.classList.contains("hub-page-class")) {
				let parent = document.querySelector(".main-wrapper>.content-holder");
				if (parent) {
					let aside = parent.querySelector(".sidebar");
					if (aside) {
						let toc = document.createElement("div");
						toc.classList.add("toc-widget");
						toc.innerHTML = res;
						aside.append(toc);
					}
					initTocWidget();
				}
			} else {
				let parent = document.querySelector("#main-content-block");
				if (parent) {
					let headings = parent.querySelectorAll("h2");
					let creditBlocks = parent.querySelectorAll(".credit-block");
					if (creditBlocks.length || headings.length) {
						if (creditBlocks.length && creditBlocks[0].offsetTop < headings[0].offsetTop) {
							let toc = document.createElement("div");
							toc.classList.add("toc-widget");
							toc.innerHTML = res;
							parent.insertBefore(toc, creditBlocks[0]);
						} else {
							let toc = document.createElement("div");
							toc.classList.add("toc-widget");
							toc.innerHTML = res;
							parent.insertBefore(toc, headings[0]);
						}
					}
					initTocWidget();
				}
			}
		},
	});
});

function initTocWidget() {
	let el = document.querySelector(".toc-widget__list");
	if (!el) return;
	let anchors = el.querySelectorAll("a");

	anchors.forEach((link) => {
		link.addEventListener("click", (event) => {
			event.preventDefault();
			if (document.body.classList.contains("toc-list-visible")) {
				document.body.classList.remove("toc-list-visible");
			}
			if (link.hash) {
				const target = document.querySelector(link.hash);
				let headerHeight = document.querySelector("#header").offsetHeight;
				let smartBannerHeight = 0;
				if(document.querySelector(".smart-banner-section")) smartBannerHeight = document.querySelector(".smart-banner-section").offsetHeight;
				let top;
				if (document.body.classList.contains("smart-banner-active")) {
					top = target.getBoundingClientRect().top + window.scrollY - headerHeight - smartBannerHeight;
				} else {
					top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
				}

				window.scrollTo({
					top: top,
					behavior: "smooth",
				});
			}
		});
	});
}


